// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__YwX8Y","active":"Modal_active__rBuBj","content":"Modal_content__aobLq","close":"Modal_close__1mg60"};